export default __webpack_public_path__ + "49dc80380d50906e9416f31670d673d5.png";